import React, { useState, useRef, useEffect } from "react";
import axios from 'axios';
import "../../../css/dashboard.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuthContext } from '../../common/ProtectedLayout';
import styled from "styled-components";
import { regionData } from "../../common/regionData";
import DaumPostcode from 'react-daum-postcode';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

function isTrainingCompleted(value) {
    return value === true || value === 1 || value === '1';
}

function ManagerDetail(props) {

    // 기사등급 색상 (배경색, 글씨색)
    const RANK_STYLES = {
        '레전드': { bg: '#FF1744', text: '#FFFFFF' },
        '라이트닝': { bg: '#FFFF00', text: '#333333' },
        '코스믹': { bg: '#1a0033', text: '#FFFFFF' },
        '토파즈': { bg: '#FF8C00', text: '#FFFFFF' },
        '아메시스트': { bg: '#9933CC', text: '#FFFFFF' },
        '에메랄드': { bg: '#50C878', text: '#FFFFFF' },
        '에메라드': { bg: '#50C878', text: '#FFFFFF' }, // 기존 데이터 호환
        '사파이어': { bg: '#0F52BA', text: '#FFFFFF' },
        '루비': { bg: '#E0115F', text: '#FFFFFF' },
        '플래티넘': { bg: '#E5E4E2', text: '#333333' },
        '골드': { bg: '#FFD700', text: '#333333' },
        '실버': { bg: '#C0C0C0', text: '#333333' },
        '브론즈': { bg: '#CD7F32', text: '#FFFFFF' },
        '아이언': { bg: '#708090', text: '#FFFFFF' }
    };

    const location = useLocation();
    const navigate = useNavigate();

    const [reserveList, setReserveList] = useState({});
    const [editData, setEditData] = useState({}); // 수정 모달용 임시 데이터
    const modalCorrective = useRef();

    const auth = useAuthContext();

    const [imagePath, setImagePath] = useState('');
    const [imageTitle, setImageTitle] = useState('증빙 서류'); // 이미지 모달 제목 상태 추가
    const imageModalRef = useRef();
    const fileInputRef = useRef();
    const [trainingCertificate, setTrainingCertificate] = useState({
        status: 'idle',
        url: ''
    });

    const careerOptions = Array.from({ length: 50 }, (_, i) => i + 1);

    const startBeforePage = () => {
        if (location.state && location.state.beforePage) {
            navigate(location.state.beforePage);
        } else {
            navigate(-1);
        }
    }

    const startModal = () => {
        setEditData({ ...reserveList }); // 모달 열 때 현재 데이터로 초기화
        modalCorrective.current.showModal();
    }

    const formatPhoneNumber = (value) => {
        const onlyNums = value.replace(/[^0-9]/g, '');
        const maxLength = 11;
        const truncatedNums = onlyNums.slice(0, maxLength);
        if (truncatedNums.length < 4) return truncatedNums;
        else if (truncatedNums.length < 7) return `${truncatedNums.slice(0, 3)}-${truncatedNums.slice(3)}`;
        else return `${truncatedNums.slice(0, 3)}-${truncatedNums.slice(3, 7)}-${truncatedNums.slice(7)}`;
    };

    // --- Change Handlers ---
    // --- Change Handlers (editData 수정) ---
    const ChangeName = (e) => setEditData({ ...editData, name: e.target.value });
    const ChangeEmail = (e) => setEditData({ ...editData, email: e.target.value });
    const ChangePhone = (e) => setEditData({ ...editData, phone_num: formatPhoneNumber(e.target.value) });
    const ChangeEmerPhone = (e) => setEditData({ ...editData, emer_phone: formatPhoneNumber(e.target.value) });
    const ChangeAddress = (e) => setEditData({ ...editData, address: e.target.value });
    const ChangeArea1 = (val) => setEditData({ ...editData, area1: val });
    const ChangeArea2 = (val) => setEditData({ ...editData, area2: val });
    const ChangeArea3 = (val) => setEditData({ ...editData, area3: val });
    const ChangeRegistDate = (e) => setEditData({ ...editData, regist_date: e.target.value });
    const ChangeRank = (e) => setEditData({ ...editData, rank: e.target.value });
    const ChangeCareer = (e) => setEditData({ ...editData, career: e.target.value });
    const ChangeCar = (e) => setEditData({ ...editData, car: e.target.value });
    const ChangeImposible = (e) => setEditData({ ...editData, imposible: e.target.value });
    const ChangeAffili = (e) => setEditData({ ...editData, affiliation: e.target.value });
    const ChangeAsCount = (e) => setEditData({ ...editData, as_count: e.target.value });
    const ChangeBank = (e) => setEditData({ ...editData, bank: e.target.value });
    const ChangeBankNum = (e) => setEditData({ ...editData, bank_num: e.target.value });

    const putManagerInfo = async () => {
        const requestData = {
            ...editData,
            emer_phone: editData.emer_phone || "",
            area1: editData.area1 || "",
            area2: editData.area2 || "",
            area3: editData.area3 || "",
            regist_date: editData.regist_date || "",
            career: editData.career || "",
            car: editData.car || "",
            imposible: editData.imposible || "",
            affili: editData.affiliation || "",
            as_count: editData.as_count || "",
            bank: editData.bank || "",
            bank_num: editData.bank_num || "",
            approve_state: editData.approve_state || "대기"
        };
        console.log('전송 데이터:', requestData);
        try {
            const put_result = await axios.put(`/ManagerRegist/${location.state.idx}`, requestData);
            if (put_result.data.success === true) {
                alert('수정이 완료되었습니다');
                setReserveList({ ...editData }); // 성공 시 원본 데이터 업데이트
                modalCorrective.current.close();
            } else {
                alert('수정에 실패하였습니다');
            }
        } catch (error) {
            console.error('Error :', error.message);
            const errMsg = error.response?.data?.message || error.message;
            alert('수정 오류: ' + errMsg);
        }
    };

    const showImage = async (type, title) => {
        try {
            setImageTitle(title); // 제목 설정
            const response = await axios.get(`/image/manager/${encodeURIComponent(reserveList.email)}/${type}`, {
                responseType: 'blob'
            });
            const imageUrl = URL.createObjectURL(response.data);
            setImagePath(imageUrl);
            imageModalRef.current.showModal();
        } catch (error) {
            console.error('Error fetching image:', error.message);
            alert("이미지를 불러올 수 없습니다.");
        }
    };

    const showTrainingCertificate = () => {
        if (!trainingCertificate.url) return;
        setImageTitle('교육 수료증');
        setImagePath(trainingCertificate.url);
        imageModalRef.current?.showModal();
    };

    const closeImageModal = () => {
        imageModalRef.current?.close();
    };

    const handleFileChange = async (e, uploadType) => {
        const selectedFile = e.target.files[0];
        if (!selectedFile) return;

        const renamedFile = new File([selectedFile], "image.jpg", { type: selectedFile.type });
        const formData = new FormData();
        formData.append('image', renamedFile);
        formData.append('user_id', reserveList.email);

        try {
            const response = await axios.post(`/image/manager/${uploadType}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            if (response.data.success) {
                alert('이미지 업로드가 완료되었습니다.');
            } else {
                alert('이미지 업로드에 실패했습니다.');
            }
        } catch (error) {
            console.error('Error uploading image:', error.message);
        } finally {
            e.target.value = null;
        }
    };

    const triggerFileSelect = (uploadType) => {
        fileInputRef.current.setAttribute("data-upload-type", uploadType);
        fileInputRef.current.click();
    };

    const [productList, setProductList] = useState([]); // 제품 리스트 상태

    useEffect(() => {
        if (!location.state || !location.state.idx) {
            console.error('Manager ID (idx) is missing from location state.');
            return;
        }
        let active = true;
        let certificateObjectUrl = '';

        const getReservationDetail = async () => {
            try {
                const reserve_result = await axios.get(`/ManagerRegistId/${location.state.idx}`);
                const manager = reserve_result.data[0];
                if (!active || !manager) return;
                setReserveList(manager);

                if (!isTrainingCompleted(manager.training_completed)) {
                    setTrainingCertificate({ status: 'idle', url: '' });
                    return;
                }

                setTrainingCertificate({ status: 'loading', url: '' });
                try {
                    const certificateResponse = await axios.get(
                        `/image/manager/${encodeURIComponent(manager.email)}/training-certificate`,
                        { responseType: 'blob' }
                    );
                    if (!active) return;
                    certificateObjectUrl = URL.createObjectURL(certificateResponse.data);
                    setTrainingCertificate({ status: 'available', url: certificateObjectUrl });
                } catch (certificateError) {
                    if (!active) return;
                    if (certificateError.response?.status !== 404) {
                        console.error('Error fetching training certificate:', certificateError.message);
                    }
                    setTrainingCertificate({
                        status: certificateError.response?.status === 404 ? 'missing' : 'error',
                        url: ''
                    });
                }
            } catch (error) {
                console.error('Error fetching reservation detail:', error.message);
            }
        };

        // ✅ [Added] 제품 리스트 가져오기
        const getProductList = async () => {
            try {
                const res = await axios.get('/PriceInfo');
                if (res.data.success) {
                    setProductList(res.data.message);
                }
            } catch (err) {
                console.error("Error fetching product list:", err);
            }
        };

        getReservationDetail();
        getProductList();

        return () => {
            active = false;
            if (certificateObjectUrl) {
                URL.revokeObjectURL(certificateObjectUrl);
            }
        };
    }, [location.state]);

    // ✅ [Added] 주소 검색 모달 상태
    const [addressModalOpen, setAddressModalOpen] = useState(false);
    const addressModalRef = useRef(); // ✅ [Added] 주소 모달 Ref

    // ✅ [Added] 모달 제어 useEffect
    useEffect(() => {
        if (addressModalOpen) {
            addressModalRef.current?.showModal();
        } else {
            addressModalRef.current?.close();
        }
    }, [addressModalOpen]);

    // ✅ [Added] 주소 검색 완료 핸들러
    const handleAddressComplete = (data) => {
        let fullAddress = data.address;
        let extraAddress = '';

        if (data.addressType === 'R') {
            if (data.bname !== '') {
                extraAddress += data.bname;
            }
            if (data.buildingName !== '') {
                extraAddress += (extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName);
            }
            fullAddress += (extraAddress !== '' ? ` (${extraAddress})` : '');
        }

        setEditData(prev => ({ ...prev, address: fullAddress }));
        setAddressModalOpen(false);
    };

    // ✅ [Added] 세척불가품목 추가 핸들러
    const handleAddImposible = (e) => {
        const selectedItem = e.target.value;
        if (!selectedItem) return;

        let currentItems = editData.imposible ? editData.imposible.split(',').map(item => item.trim()).filter(item => item && item !== '없음') : [];
        if (!currentItems.includes(selectedItem)) {
            currentItems.push(selectedItem);
            setEditData({ ...editData, imposible: currentItems.join(', ') });
        }
    };

    // ✅ [Added] 세척불가품목 삭제 핸들러
    const handleRemoveImposible = (itemToRemove) => {
        let currentItems = editData.imposible ? editData.imposible.split(',').map(item => item.trim()).filter(item => item && item !== '없음') : [];
        const newItems = currentItems.filter(item => item !== itemToRemove);
        setEditData({ ...editData, imposible: newItems.join(', ') });
    };

    // ✅ [Added] 매니저 탈퇴 핸들러
    const handleWithdraw = async () => {
        if (window.confirm("정말로 탈퇴 처리하시겠습니까? 이 작업은 되돌릴 수 없습니다.")) {
            try {
                const response = await axios.delete(`/ManagerRegist/${reserveList.email}`);
                if (response.data.success) {
                    alert('매니저 탈퇴 처리가 완료되었습니다.');
                    modalCorrective.current.close();
                    navigate(-1); // 목록으로 돌아가기
                } else {
                    alert(response.data.message || '탈퇴 처리에 실패했습니다.');
                }
            } catch (error) {
                console.error('Error withdrawing manager:', error);
                alert(error.response?.data?.message || '탈퇴 처리 중 오류가 발생했습니다.');
            }
        }
    };

    return (
        <PageContainer>
            <Card>
                <CardHeader>
                    <Title>매니저 상세 정보</Title>
                </CardHeader>

                <SectionTitle>기본 정보</SectionTitle>
                <GridContainer>
                    <InfoItem label="이름" value={reserveList.name} />
                    <InfoItem label="E-mail" value={reserveList.email} />
                    <InfoItem label="연락처" value={reserveList.phone_num} />
                    <InfoItem label="비상연락망" value={reserveList.emer_phone} />
                    <InfoItem label="은행이름" value={reserveList.bank} />
                    <InfoItem label="계좌번호" value={reserveList.bank_num} />
                    <InfoItem label="주소" value={reserveList.address} span={2} />
                </GridContainer>

                <SectionTitle>근무 정보</SectionTitle>
                <GridContainer>
                    <InfoItem label="가입일자" value={reserveList.regist_date} />
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                        <Label>기사등급</Label>
                        {reserveList.rank && RANK_STYLES[reserveList.rank] ? (
                            <RankBadge style={{
                                backgroundColor: RANK_STYLES[reserveList.rank].bg,
                                color: RANK_STYLES[reserveList.rank].text
                            }}>
                                {reserveList.rank}
                            </RankBadge>
                        ) : (
                            <Value>-</Value>
                        )}
                    </div>
                    <InfoItem label="기사경력" value={`${reserveList.career}년`} />
                    <InfoItem label="AS 횟수" value={reserveList.as_count} />
                    <InfoItem label="소속" value={reserveList.affiliation} />
                    <InfoItem label="차량유무" value={reserveList.car} />
                    <InfoItem label="교육비 결제" value={reserveList.paid ? '결제완료' : '미결제'} />
                    <TrainingCertificateItem>
                        <Label>교육 이수</Label>
                        {isTrainingCompleted(reserveList.training_completed) ? (
                            <>
                                {trainingCertificate.status === 'loading' ? (
                                    <CertificateStatus>수료증을 불러오는 중입니다.</CertificateStatus>
                                ) : trainingCertificate.status === 'available' ? (
                                    <CertificateThumbnailButton
                                        type="button"
                                        onClick={showTrainingCertificate}
                                        aria-label={`${reserveList.name || '매니저'} 교육 수료증 확대 보기`}
                                    >
                                        <CertificateThumbnail
                                            src={trainingCertificate.url}
                                            alt={`${reserveList.name || '매니저'} 교육 수료증 미리보기`}
                                        />
                                        <CertificateZoomHint>눌러서 확대</CertificateZoomHint>
                                    </CertificateThumbnailButton>
                                ) : (
                                    <CertificateStatus>
                                        {trainingCertificate.status === 'error'
                                            ? '수료증을 불러오지 못했습니다.'
                                            : '등록된 수료증 이미지가 없습니다.'}
                                    </CertificateStatus>
                                )}
                            </>
                        ) : (
                            <Value>미이수</Value>
                        )}
                    </TrainingCertificateItem>
                    <InfoItem label="선호지역" value={`${reserveList.area1 || ''} ${reserveList.area2 || ''} ${reserveList.area3 || ''}`} span={2} />
                    <InfoItem label="세척불가품목" value={reserveList.imposible} span={4} />
                </GridContainer>

                <SectionTitle>증빙 서류</SectionTitle>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '15px', marginTop: '15px' }}>
                    <FileItem label="사업자등록증" onClick={() => showImage('certification', '사업자등록증')} />
                    <FileItem label="통장사본" onClick={() => showImage('bank', '통장사본')} />
                    <FileItem label="통신가입 이용증명" onClick={() => showImage('call', '통신가입 이용증명')} />
                    <FileItem label="PL보험 가입증서" onClick={() => showImage('pl_insurance', 'PL보험 가입증서')} />
                </div>

                <ButtonGroup>
                    <div style={{ marginRight: 'auto' }}>
                        <OutlineButton onClick={handleWithdraw} style={{ borderColor: '#dc3545', color: '#dc3545' }}>탈퇴</OutlineButton>
                    </div>
                    <OutlineButton onClick={startBeforePage}>목록으로</OutlineButton>
                    <PrimaryButton onClick={startModal}>수정하기</PrimaryButton>
                </ButtonGroup>
            </Card>

            {/* 수정 모달 */}
            <StyledDialog ref={modalCorrective}>
                <DialogHeader>
                    <h3>매니저 정보 수정</h3>
                </DialogHeader>
                <DialogContent>
                    <SectionTitle>인적 사항</SectionTitle>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '20px' }}>
                        <InputGroup label="이름" value={editData.name} onChange={ChangeName} />
                        <InputGroup label="E-mail" value={editData.email} readOnly />
                        <InputGroup label="연락처" value={editData.phone_num} onChange={ChangePhone} />
                        <InputGroup label="비상연락망" value={editData.emer_phone} onChange={ChangeEmerPhone} />
                        <InputGroup label="은행이름" value={editData.bank} onChange={ChangeBank} />
                        <InputGroup label="계좌번호" value={editData.bank_num} onChange={ChangeBankNum} />
                    </div>

                    {/* ✅ [Updated] 주소 검색 기능 추가 */}
                    <div style={{ marginBottom: '15px' }}>
                        <Label>주소</Label>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <StyledInput value={editData.address || ''} onChange={ChangeAddress} style={{ flex: 1 }} />
                            <OutlineButton onClick={() => setAddressModalOpen(true)} style={{ whiteSpace: 'nowrap' }}>주소 검색</OutlineButton>
                        </div>
                    </div>

                    <SectionTitle style={{ marginTop: '20px' }}>근무 조건</SectionTitle>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '15px', marginBottom: '20px' }}>
                        <InputGroup label="가입일자" type="date" value={editData.regist_date} onChange={ChangeRegistDate} />
                        <div>
                            <Label>기사등급</Label>
                            <StyledSelect
                                value={editData.rank || ''}
                                onChange={ChangeRank}
                                style={{
                                    borderColor: RANK_STYLES[editData.rank]?.bg || '#ddd',
                                    borderWidth: '2px'
                                }}
                            >
                                <option value="레전드">● 레전드 (수수료 26%)</option>
                                <option value="라이트닝">● 라이트닝 (수수료 28%)</option>
                                <option value="코스믹">● 코스믹 (수수료 30%)</option>
                                <option value="토파즈">● 토파즈 (수수료 32%)</option>
                                <option value="아메시스트">● 아메시스트 (수수료 34%)</option>
                                <option value="에메랄드">● 에메랄드 (수수료 36%)</option>
                                <option value="사파이어">● 사파이어 (수수료 38%)</option>
                                <option value="루비">● 루비 (수수료 40%)</option>
                                <option value="플래티넘">● 플래티넘 (수수료 42%)</option>
                                <option value="골드">● 골드 (수수료 44%)</option>
                                <option value="실버">● 실버 (수수료 46%)</option>
                                <option value="브론즈">● 브론즈 (수수료 48%)</option>
                                <option value="아이언">● 아이언 (수수료 50%)</option>
                            </StyledSelect>
                        </div>
                        <div>
                            <Label>기사경력</Label>
                            <StyledSelect value={editData.career || ''} onChange={ChangeCareer}>
                                {careerOptions.map(year => (<option key={year} value={year}>{year}년</option>))}
                            </StyledSelect>
                        </div>
                        <div>
                            <Label>차량유무</Label>
                            <StyledSelect value={editData.car || ''} onChange={ChangeCar}>
                                <option value="유">있음</option>
                                <option value="무">없음</option>
                            </StyledSelect>
                        </div>
                        <InputGroup label="소속" value={editData.affiliation} onChange={ChangeAffili} />
                        <InputGroup label="AS횟수" value={editData.as_count} onChange={ChangeAsCount} />
                    </div>

                    <Label>선호지역</Label>
                    <div style={{ display: 'flex', gap: '10px', marginBottom: '15px', flexDirection: 'column' }}>
                        <RegionSelect
                            value={editData.area1 || ''}
                            onChange={ChangeArea1}
                            excludeRegions={[editData.area2, editData.area3].filter(Boolean)}
                        />
                        <RegionSelect
                            value={editData.area2 || ''}
                            onChange={ChangeArea2}
                            excludeRegions={[editData.area1, editData.area3].filter(Boolean)}
                        />
                        <RegionSelect
                            value={editData.area3 || ''}
                            onChange={ChangeArea3}
                            excludeRegions={[editData.area1, editData.area2].filter(Boolean)}
                        />
                    </div>

                    {/* ✅ [Updated] 세척불가품목 멀티 셀렉트 UI */}
                    <div style={{ marginBottom: '20px' }}>
                        <Label>세척불가품목</Label>
                        <StyledSelect onChange={handleAddImposible} value="">
                            <option value="">품목 선택</option>
                            {productList
                                .filter(product => {
                                    const currentItems = editData.imposible ? editData.imposible.split(',').map(item => item.trim()) : [];
                                    return !currentItems.includes(product.kind);
                                })
                                .map((product, idx) => (
                                    <option key={idx} value={product.kind}>{product.kind}</option>
                                ))
                            }
                        </StyledSelect>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '8px' }}>
                            {editData.imposible && editData.imposible.split(',').map(item => item.trim()).filter(item => item && item !== '없음').map((item, idx) => (
                                <Badge key={idx} style={{ display: 'flex', alignItems: 'center', gap: '5px', paddingRight: '6px' }}>
                                    {item}
                                    <span
                                        onClick={() => handleRemoveImposible(item)}
                                        style={{ cursor: 'pointer', fontWeight: 'bold', fontSize: '1.1em', lineHeight: 0.8 }}
                                    >
                                        &times;
                                    </span>
                                </Badge>
                            ))}
                        </div>
                    </div>

                    <SectionTitle style={{ marginTop: '20px' }}>증빙 서류 수정</SectionTitle>
                    <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
                        <SmallOutlineButton onClick={() => triggerFileSelect('certification')}>사업자등록증 변경</SmallOutlineButton>
                        <SmallOutlineButton onClick={() => triggerFileSelect('bank')}>통장사본 변경</SmallOutlineButton>
                        <SmallOutlineButton onClick={() => triggerFileSelect('call')}>통신가입증명 변경</SmallOutlineButton>
                        <SmallOutlineButton onClick={() => triggerFileSelect('pl_insurance')}>PL보험 가입증서 변경</SmallOutlineButton>
                    </div>
                    <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                        onChange={(e) => handleFileChange(e, fileInputRef.current.getAttribute("data-upload-type"))}
                    />
                </DialogContent>
                <DialogActions>
                    <OutlineButton onClick={() => modalCorrective.current.close()}>취소</OutlineButton>
                    <PrimaryButton onClick={putManagerInfo}>저장하기</PrimaryButton>
                </DialogActions>
            </StyledDialog>

            {/* ✅ [Added] 주소 검색 모달 */}
            <StyledDialog ref={addressModalRef} onClose={() => setAddressModalOpen(false)}>
                <DialogHeader>
                    <h3>주소 검색</h3>
                    <CloseButton onClick={() => setAddressModalOpen(false)}>&times;</CloseButton>
                </DialogHeader>
                <DialogContent>
                    {addressModalOpen && <DaumPostcode onComplete={handleAddressComplete} />}
                </DialogContent>
            </StyledDialog>

            {/* ✅ [수정] 이미지 모달 (헤더 및 확인 버튼 추가) */}
            <StyledDialog ref={imageModalRef}>
                <DialogHeader>
                    <h3>{imageTitle}</h3>
                </DialogHeader>
                <DialogContent style={{ padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '300px' }}>
                    {imagePath ? (
                        <TransformWrapper
                            key={imagePath}
                            initialScale={1}
                            minScale={0.5}
                            maxScale={5}
                            centerOnInit
                        >
                            <TransformComponent
                                wrapperStyle={{ width: '100%', height: '60vh' }}
                                contentStyle={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                            >
                                <img src={imagePath} alt={imageTitle} style={{ maxWidth: '100%', maxHeight: '60vh', objectFit: 'contain' }} />
                            </TransformComponent>
                        </TransformWrapper>
                    ) : (
                        <div style={{ color: '#999' }}>이미지를 불러올 수 없습니다.</div>
                    )}
                </DialogContent>
                <DialogActions>
                    <PrimaryButton onClick={closeImageModal}>확인</PrimaryButton>
                </DialogActions>
            </StyledDialog>

        </PageContainer>
    )
}

// --- Helper Components ---
const InfoItem = ({ label, value, span = 1, isHighlight, color }) => (
    <div style={{ gridColumn: `span ${span}`, display: 'flex', flexDirection: 'column', gap: '2px' }}>
        <Label>{label}</Label>
        <Value isHighlight={isHighlight} style={{ color: color }}>{value || '-'}</Value>
    </div>
);

const FileItem = ({ label, onClick }) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
        <Label>{label}</Label>
        <SecondaryButton onClick={onClick} style={{ fontSize: '0.85rem', padding: '6px 12px' }}>보기</SecondaryButton>
    </div>
);

const InputGroup = ({ label, value, onChange, type = "text", readOnly = false }) => (
    <div>
        <Label>{label}</Label>
        <StyledInput type={type} value={value || ''} onChange={onChange} readOnly={readOnly} style={readOnly ? { backgroundColor: '#f0f0f0', cursor: 'not-allowed' } : {}} />
    </div>
);

// --- Styled Components (80% Compact) ---

const PageContainer = styled.div`
    padding: 20px;
    background-color: #f5f6f8;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 40px;
    box-sizing: border-box;
`;

const Card = styled.div`
    background: white;
    width: 100%;
    max-width: 1000px;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    padding: 32px 36px;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

const CardHeader = styled.div`
    display: flex; justify-content: space-between; align-items: center;
    border-bottom: 1px solid #eee;
    padding-bottom: 12px;
    margin-bottom: 8px;
`;

const Title = styled.h2`
    font-size: 1.5rem; color: #111; margin: 0; font-weight: 800;
`;

const Badge = styled.span`
    padding: 4px 10px; border-radius: 20px; font-size: 0.8rem; font-weight: 600;
    background-color: #e3f2fd; color: #1976d2;
`;

const RankBadge = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 6px 16px;
    border-radius: 20px;
    font-size: 0.9rem;
    font-weight: 700;
    text-shadow: 0 1px 2px rgba(0,0,0,0.2);
    box-shadow: 0 2px 4px rgba(0,0,0,0.15);
    width: fit-content;
`;

const SectionTitle = styled.h3`
    font-size: 1.1rem; color: #333; margin: 0 0 10px 0;
    border-left: 4px solid #006edc; padding-left: 10px;
`;

const GridContainer = styled.div`
    display: grid; grid-template-columns: repeat(4, 1fr);
    column-gap: 20px; row-gap: 16px;
    @media (max-width: 768px) { grid-template-columns: repeat(2, 1fr); }
`;

const TrainingCertificateItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
`;

const CertificateThumbnailButton = styled.button`
    position: relative;
    width: 100%;
    max-width: 180px;
    min-height: 112px;
    padding: 7px;
    border: 1px solid #dfe5ec;
    border-radius: 10px;
    background: #f8fafc;
    box-sizing: border-box;
    cursor: zoom-in;
    overflow: hidden;
    transition: border-color 0.2s, box-shadow 0.2s, transform 0.2s;

    &:hover {
        border-color: #006edc;
        box-shadow: 0 4px 14px rgba(0, 110, 220, 0.16);
        transform: translateY(-1px);
    }

    &:focus-visible {
        outline: 3px solid rgba(0, 110, 220, 0.25);
        outline-offset: 2px;
    }
`;

const CertificateThumbnail = styled.img`
    display: block;
    width: 100%;
    height: 98px;
    object-fit: contain;
    background: white;
    border-radius: 6px;
`;

const CertificateZoomHint = styled.span`
    position: absolute;
    right: 10px;
    bottom: 10px;
    padding: 3px 7px;
    border-radius: 10px;
    background: rgba(17, 24, 39, 0.78);
    color: white;
    font-size: 0.7rem;
    font-weight: 600;
`;

const CertificateStatus = styled.div`
    min-height: 22px;
    padding: 10px 12px;
    border-radius: 8px;
    background: #f5f6f8;
    color: #777;
    font-size: 0.85rem;
`;

const Label = styled.div`
    font-size: 0.8rem; color: #888; font-weight: 500; margin-bottom: 3px;
`;

const Value = styled.div`
    font-size: 0.95rem;
    color: ${props => props.isHighlight ? '#d32f2f' : '#222'};
    font-weight: ${props => props.isHighlight ? 'bold' : 'normal'};
    border-bottom: 1px solid #f0f0f0; padding-bottom: 5px; min-height: 22px;
    word-break: break-all;
`;

const ButtonGroup = styled.div`
    display: flex; justify-content: flex-end; gap: 10px;
    margin-top: 20px; padding-top: 20px; border-top: 1px solid #eee;
`;

const BaseButton = styled.button`
    padding: 8px 18px; border-radius: 8px; font-weight: 600;
    cursor: pointer; transition: all 0.2s; border: none; font-size: 0.9rem;
`;

const PrimaryButton = styled(BaseButton)`
    background-color: #006edc; color: white;
    &:hover { background-color: #0056b3; }
`;

const SecondaryButton = styled(BaseButton)`
    background-color: #f0f0f0; color: #333;
    &:hover { background-color: #e0e0e0; }
`;

const OutlineButton = styled(BaseButton)`
    background-color: white; border: 1px solid #ccc; color: #555;
    &:hover { background-color: #f9f9f9; border-color: #bbb; }
`;

const SmallOutlineButton = styled(OutlineButton)`
    padding: 6px 12px; font-size: 0.85rem;
`;

const StyledInput = styled.input`
    width: 100%; padding: 8px 10px; border: 1px solid #ddd;
    border-radius: 6px; font-size: 0.95rem; box-sizing: border-box;
    &:focus { border-color: #006edc; outline: none; }
`;

const StyledSelect = styled.select`
    width: 100%; padding: 8px 10px; border: 1px solid #ddd;
    border-radius: 6px; font-size: 0.95rem; box-sizing: border-box;
    background-color: white;
    &:focus { border-color: #006edc; outline: none; }
`;

// --- Modal Styles ---
const StyledDialog = styled.dialog`
    border: none; border-radius: 16px; padding: 0;
    width: 90%; max-width: 900px;
    box-shadow: 0 10px 40px rgba(0,0,0,0.25);
    &::backdrop { background: rgba(0, 0, 0, 0.6); }
`;

const DialogHeader = styled.div`
    padding: 16px 20px; border-bottom: 1px solid #eee;
    display: flex; justify-content: space-between; align-items: center;
    h3 { margin: 0; font-size: 1.2rem; font-weight: 700; }
`;

const DialogContent = styled.div`
    padding: 24px; background: #fff; max-height: 80vh; overflow-y: auto;
    display: flex; flex-direction: column;
`;

const DialogActions = styled.div`
    padding: 16px 20px; border-top: 1px solid #eee;
    display: flex; justify-content: flex-end; gap: 10px;
`;

const CloseButton = styled.button`
    background: none; border: none; font-size: 1.8rem; cursor: pointer; color: #999; line-height: 1;
    &:hover { color: #333; }
`;

export default ManagerDetail;

const RegionSelect = ({ value, onChange, excludeRegions = [] }) => {
    // value format: "Province District" (e.g., "서울 강남구")
    const [province, setProvince] = useState('');
    const [district, setDistrict] = useState('');

    useEffect(() => {
        if (value) {
            const parts = value.split(' ');
            if (parts.length >= 1) setProvince(parts[0]);
            if (parts.length >= 2) setDistrict(parts[1]);
        } else {
            setProvince('');
            setDistrict('');
        }
    }, [value]);

    const handleProvinceChange = (e) => {
        const newProvince = e.target.value;
        setProvince(newProvince);
        setDistrict('');
        onChange(newProvince ? `${newProvince}` : '');
    };

    const handleDistrictChange = (e) => {
        const newDistrict = e.target.value;
        setDistrict(newDistrict);
        onChange(province ? `${province} ${newDistrict}` : newDistrict);
    };

    // Check if a district is excluded
    const isExcluded = (prov, dist) => {
        const fullRegion = `${prov} ${dist}`;
        return excludeRegions.includes(fullRegion);
    };

    return (
        <div style={{ display: 'flex', gap: '5px', flex: 1 }}>
            <StyledSelect value={province} onChange={handleProvinceChange}>
                <option value="">시/도</option>
                {Object.keys(regionData).map(prov => (
                    <option key={prov} value={prov}>{prov}</option>
                ))}
            </StyledSelect>
            <StyledSelect value={district} onChange={handleDistrictChange} disabled={!province}>
                <option value="">시/구/군</option>
                {province && regionData[province]?.map(dist => (
                    <option key={dist} value={dist} disabled={isExcluded(province, dist)}>
                        {dist} {isExcluded(province, dist) ? '(선택됨)' : ''}
                    </option>
                ))}
            </StyledSelect>
        </div>
    );
};
